import React from 'react';
import { observer } from 'mobx-react';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';

const CashbackMainContent = React.lazy(() => import('./CashbackMainContent'));
const PointsMainContent = React.lazy(() => import('./PointsMainContent'));

const MainContent: React.FC = observer(() => (AppStore.isCashbackProgram ? <CashbackMainContent /> : <PointsMainContent />));

export default MainContent;
